import { useContext, useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { translate, getNameIncidentsTypes } from "../../../utils/Common";
import ThemeContext from "../../../contexts/theme";
import { useIncidents } from "../../../hooks/useIncidents";
import { getReactSelectStyles } from "../../../utils/reactSelectThemeStyles";
import { IoSettingsOutline } from "react-icons/io5";
import ignoreAbort from '../../../utils/ignoreAbort';
import { SelectShell } from "@/components/ui/select-shell";

const TypeIncidentSelect = (props) => {
  const { register, errors, setValue, nameShow, idShow, readOnly, sizeInput } = props;
  const themeContext = useContext(ThemeContext);
  const theme = themeContext?.theme || "light";
  const selectStyles = useMemo(() => getReactSelectStyles(theme, { hasIcon: true }), [theme]);
  const { typesIncidents, getTypes } = useIncidents();
  const [typesList, setTypesList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const abortController = new AbortController();

    const loadTypes = async () => {
      setLoading(true);
      const response = await getTypes(abortController.signal);
      if (response && Array.isArray(response)) {
        setTypesList(response);
      } else {
        setTypesList([]);
      }
      setLoading(false);
    };

    if (!typesIncidents) {
      loadTypes().catch(ignoreAbort);
    } else {
      setTypesList(typesIncidents);
      setLoading(false);
    }

    return () => abortController.abort();
  }, [typesIncidents, getTypes]);

  const selectOptions = useMemo(
    () =>
      typesList.map((item) => ({
        value: item.id,
        label: getNameIncidentsTypes(item.id) || String(item.id),
        ...item,
      })),
    [typesList]
  );

  const fieldName = "typeIncident";
  const hiddenValue = selectedOption?.value ?? (idShow ?? "");

  return (
    <SelectShell icon={<IoSettingsOutline size={16} />} error={errors?.[fieldName]}>
        <Select
          value={selectedOption}
          options={selectOptions}
          isLoading={loading}
          placeholder={nameShow || translate("global.select")}
          name={fieldName}
          onChange={(e) => {
            setSelectedOption(e);
            if (setValue) {
              setValue(fieldName, e ? e.value : "", { shouldValidate: true });
            }
          }}
          isClearable
          isSearchable
          filterOption={(option, search) =>
            (option.label || "")
              .toLowerCase()
              .includes((search || "").toLowerCase())
          }
          noOptionsMessage={() => translate("global.noResults")}
          styles={selectStyles}
          isDisabled={readOnly}
        />
      <input
        type="hidden"
        name={fieldName}
        value={hiddenValue}
        ref={register({
          validate: (value) =>
            (value !== "" && value !== translate("global.select") && value !== translate("global.noResults")) ||
            translate("global.chooseValidTypeIncident"),
        })}
      />
    </SelectShell>
  );
};

export default TypeIncidentSelect;
